import React from 'react';
import { Collapse, Typography } from 'antd';

const { Title, Paragraph } = Typography;

const FAQ_ITEMS = [
  {
    key: '1',
    label: 'What is an ABHA ID?',
    children:
      'ABHA (Ayushman Bharat Health Account) is a 14-digit unique health identifier issued under the Ayushman Bharat Digital Mission (ABDM). It helps you securely store, manage, and share your health records digitally across hospitals and clinics in India.',
  },
  {
    key: '2',
    label: 'Is creating an ABHA ID free?',
    children:
      'Yes, creating and using your ABHA ID is completely free for all Indian citizens. There are no charges for registration, storage, or sharing of health records through the ABHA system.',
  },
  {
    key: '3',
    label: 'What documents do I need to create an ABHA ID?',
    children:
      'You only need your 12-digit Aadhaar number and the mobile number linked to your Aadhaar. The OTP will be sent to your Aadhaar-linked mobile for verification.',
  },
  {
    key: '4',
    label: 'Is my health data secure with ABHA?',
    children:
      'Yes, your data is stored on government-secured ABDM infrastructure with full encryption. You control who can access your health records by giving and revoking consent at any time.',
  },
  {
    key: '5',
    label: 'Can I use ABHA at any hospital or clinic?',
    children:
      'ABHA works at all hospitals, clinics, and health facilities registered under the Ayushman Bharat Digital Mission. The network is growing rapidly across India with thousands of new healthcare providers joining every month.',
  },
  {
    key: '6',
    label: 'What if I forget my ABHA ID?',
    children:
      'You can retrieve your ABHA ID using your Aadhaar number, registered mobile number, or ABHA address. Simply use the "Fetch ABHA" options available on this platform to recover your account.',
  },
];

const FAQ = () => {
  return (
    <section id="faq" className="section-padding bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-14">
          <div
            className="inline-block px-4 py-1 rounded-full text-xs font-bold tracking-widest mb-4"
            style={{ background: '#f0eaff', color: '#6B35D4', letterSpacing: '0.1em' }}
          >
            FAQ
          </div>
          <Title level={2} style={{ color: '#1a1a2e' }}>
            Frequently Asked Questions
          </Title>
          <Paragraph style={{ color: '#666', fontSize: 16 }}>
            Everything you need to know about ABHA Health ID.
          </Paragraph>
        </div>

        <Collapse
          accordion
          expandIconPlacement="end"
          items={FAQ_ITEMS}
          style={{
            background: 'transparent',
            border: 'none',
          }}
          className="faq-collapse"
        />
      </div>
    </section>
  );
};

export default FAQ;
